module.exports = __webpack_public_path__ + "img/footer_o.d235d3e2.png";